import { setCookie, getCookie } from "../cookie";

$(".form--stores").on("submit", function(e) {
  e.preventDefault();
  const $form = $(this);
  const inputValue = $form.find(".field").val();
  const redirectUrl = $form.data("store-page") + "?search=true";
  setCookie("storeAddress", inputValue);
  window.location.href = window.location.origin + redirectUrl;
});

const searchAttr = window.location.search;
if (searchAttr.match(/\?search=true/)) {
  const $storeForm = $(".stores .search-stores form");
  $storeForm.find(".field").val(getCookie("storeAddress"));
}



// WEBPACK FOOTER //
// ../assets/js/map/stores-form.js